import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import Grid from '../../components/Grid';
import Icon from '../../components/Icon';
import Button from '../../components/Button';
import Loader from '../../components/Loader';
import { addCommas } from './utils';

const getColumnWidth = (open, deleting) => ((open === true) && (deleting === false) ? 16 : 4);

const getAdditionalStyles =
  (open, scholarshipName) => (`${open ? 'openNameWidth' : 'closedNameWidth'}${String(scholarshipName).length > 30 ? ' longName' : ''}`);

const getAwardAmount = (awardType, awAmountMin, awAmountMax) => {
  if (awardType === 'FULL_TUITION') return 'Full Tuition';
  const suffix = awardType === 'RANGE' ? ` - $${addCommas(awAmountMax)}` : '';
  return `$${addCommas(awAmountMin)}${suffix}`;
};

const AccordionTitle = ({ index, open, scholarshipName, awardType, awAmountMin, awAmountMax, renewable, deleting, onEdit, onDelete }) => (
  <React.Fragment>
    <Grid stackable centered={!open || deleting} columns="equal">
      <Grid.Row>
        <Grid.Column textAlign="left" width={getColumnWidth(open, deleting, index)} styleName="scholarship-accordion-icon-column">
          <Grid.Row>
            <Icon
              name={`chevron ${open === true ? 'left' : 'right'}`}
              styleName={`merit-scholarships-form-icon ${open === true ? 'open' : ''}`}
              key={`scholarship-accordion-icon-open-${index}`}
              data-cy={`scholarship-accordion-icon-${open === true ? 'open' : 'closed'}`}
              aria-label="Click to save and collapse scholarship details"
              tabIndex={0}
            />
            <div
              styleName={`merit-scholarships-form-scholarship-div ${getAdditionalStyles(open, scholarshipName)}`}
              data-cy="scholarship-accordion-scholarship-name"
            >
              {scholarshipName}
            </div>
          </Grid.Row>
        </Grid.Column>
        {(open === false || deleting) && (
        <React.Fragment>
          <Grid.Column textAlign="center" data-cy="scholarship-accordion-closed-award-amount">
            {getAwardAmount(awardType, awAmountMin, awAmountMax)}
          </Grid.Column>
          <Grid.Column textAlign="center" data-cy="scholarship-accordion-closed-renewable">
            {renewable ? 'Renewable' : 'One-time'}
          </Grid.Column>
          <Grid.Column textAlign="center">
            <Grid.Row styleName="merit-scholarships-form-closed-buttons-row">
              <Button
                basic
                onClick={onEdit}
                key={`scholarship-accordion-button-edit-${index}`}
                data-cy="scholarship-accordion-button-edit"
                aria-label="Click to edit scholarship details"
                tabIndex={0}
              >
                Edit
              </Button>
              <Button
                negative
                basic
                onClick={onDelete}
                key={`scholarship-accordion-button-delete-${index}`}
                data-cy="scholarship-accordion-button-delete"
                aria-label="Click to delete scholarship"
                tabIndex={0}
              >
                Delete
              </Button>
            </Grid.Row>
          </Grid.Column>
        </React.Fragment>
        )}
      </Grid.Row>
      {deleting && (
      <Grid.Row centered styleName="merit-scholarships-deleting-loader-row">
        <Loader styleName="merit-scholarships-deleting-loader" data-cy="merit-scholarships-deleting-loader" active />
      </Grid.Row>
      )}
    </Grid>
  </React.Fragment>
);

AccordionTitle.propTypes = {
  open: PropTypes.bool,
  index: PropTypes.string,
  scholarshipName: PropTypes.string,
  awardType: PropTypes.string,
  awAmountMin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  awAmountMax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  deleting: PropTypes.bool,
  renewable: PropTypes.bool,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
};

export default AccordionTitle;
